export default "__VITE_ASSET__BOMF3ciw__"